import { _ as _asyncToGenerator, r as regenerator } from '../index-33ee6c9f.js';
import { RECAPTCHA_SITE_KEY } from '../configs/constants/index.js';

var getReCaptchaToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(action) {
    var recaptchaToken;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return new Promise(function (resolve) {
            window.grecaptcha.enterprise.ready( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
              var token;
              return regenerator.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return window.grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, {
                      action: action,
                      fast: true
                    });
                  case 3:
                    token = _context.sent;
                    return _context.abrupt("return", resolve(token));
                  case 7:
                    _context.prev = 7;
                    _context.t0 = _context["catch"](0);
                    return _context.abrupt("return", resolve(''));
                  case 10:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[0, 7]]);
            })));
          });
        case 3:
          recaptchaToken = _context2.sent;
          return _context2.abrupt("return", {
            status: 'success',
            token: recaptchaToken
          });
        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2["catch"](0);
          console.error(_context2.t0);
          return _context2.abrupt("return", {
            status: 'error',
            token: ''
          });
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 7]]);
  }));
  return function getReCaptchaToken(_x) {
    return _ref.apply(this, arguments);
  };
}();

export { getReCaptchaToken as default };
//# sourceMappingURL=index.js.map
